module.exports = __webpack_public_path__ + "static/media/icon-solutions-03.812528ad.svg";